import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user dashboard data */
export const getNotificationCount = async () => {
  const res = await get(`/external-api/get_admin_dashboard_stats`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetNotificationCount = (onSuccess: any, onError: any) => {
  return useQuery('notification-stats', getNotificationCount, {
    refetchOnWindowFocus: true,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetNotificationCount;
